import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

export const PreferencesSectionLayout = ({
    title,
    editButtons,
    children,
}: {
    title: string;
    editButtons?: ReactNode;
    children: ReactNode;
}) => (
    <Box
        display='flex'
        flexDirection={'column'}
        gap={4}
        p={2}
        sx={{ border: '1px solid #E0E0E0' }}
        minWidth={'350px'}
    >
        <Box display={'flex'} flexWrap={'wrap'}>
            <Typography variant='h3' lineHeight={'24px'} fontWeight={500} mb={1}>
                {title}
            </Typography>
            {editButtons && <Box ml={'auto'}>{editButtons}</Box>}
        </Box>
        {children}
    </Box>
);
